import { SITE_NAME } from "@/helper/constant";
import { t, localePrefix } from "@/helper/helper";
import { baseURL } from "@/services/api";
import { GetStaticProps } from "next";
import Head from "next/head";
import Link from "next/link";
import styled from "styled-components";

interface Props {
  locale: string;
  data: {
    data: {
      text: string;
    };
  };
}

export default function Loan({ locale, data }: Props) {
  return (
    <Wrapper className="terms">
      <Head>
        <title>{SITE_NAME + " | " + t("loan-terms", locale)}</title>
      </Head>
      <div className="breadcrumb">
        <Link href={`${localePrefix(locale) || "/"}`}>{t("homePage", locale)}</Link>
        <span className="breadcrumb-seperator" />
        <Link href={`${localePrefix(locale)}/loan-terms`}>{t("loan-terms", locale)}</Link>
      </div>
      <div
        className="terms-content"
        dangerouslySetInnerHTML={{
          __html: data?.data?.text || "",
        }}
      />
    </Wrapper>
  );
}

export const getStaticProps: GetStaticProps = async (ctx) => {
  try {
    const { locale } = ctx;

    const res = await fetch(baseURL + "/loan-terms", {
      headers: {
        "x-localization": locale ? locale : "az",
      },
    });
    const data = await res.json();

    return {
      props: {
        locale,
        data,
      },
      revalidate: 60,
    };
  } catch (error) {
    return {
      notFound: true,
    };
  }
};

const Wrapper = styled.div`
  min-height: calc(100vh - 400px);

  &.terms {
    width: 1289px;
    margin: 0 auto;
    padding-bottom: 7rem;
    padding-top: 3.2rem;

    .terms-content {
      margin-top: 36px;
      width: 812px;
      margin: auto;

      h1.title {
        font-style: normal;
        font-weight: bold;
        font-size: 3.6rem;
        line-height: 150%;
        color: #040941;
        margin-bottom: 2.4rem;
        text-align: center;
        margin-top: 3.2rem;
      }

      h2 {
        font-style: normal;
        font-weight: bold;
        font-size: 1.7rem;
        line-height: 150%;
        color: #040941;
        margin-bottom: 2.4rem;
        text-align: left;
        margin-top: 3.2rem;
      }

      p {
        font-style: normal;
        font-weight: 500;
        font-size: 2rem;
        line-height: 30px;
        color: #989eaf;
        margin-bottom: 1.6rem;
      }
    }

    @media (max-width: 1199px) {
      width: 100%;
      padding: 0 16px;

      .terms-content {
        width: 100%;

        p {
          font-size: 1.6rem;
        }
      }
    }
  }
`;
